import { useActionsColumn } from '../../../../features/table/helpers/useActionsColumn';
import { DemandsActionsBodyCell } from './DemandsActionsBodyCell';

export const useDemandActionsColumn = () => {
  return useActionsColumn({
    render: (text: string, row: any) => <DemandsActionsBodyCell row={row} />,
  });
};
